export default __webpack_public_path__ + "static/media/CareEvent3-min.ed332832.png";